import type {World} from '../shared/types';
import {mergeWorld} from './worldState';

/** A partial reconnect snapshot cannot certify previously cached offscreen
 * blocks. Refresh those in the API's six-block batches before advancing the
 * synchronized revision. Keep unrelated cached geometry/drafts intact. */
export async function refreshModeratedWorld(first:World,cached:World|null,requested:readonly number[],synchronizedRevision:number,read:(blocks:number[])=>Promise<World>):Promise<World>{
  if(!cached||(first.worldEpoch??0)!==(cached.worldEpoch??0)||(first.moderationRevision??0)<=synchronizedRevision)return first;
  const all=[...new Set([...requested,...cached.surfaces.map(surface=>surface.blockId)])];
  let snapshot=first;
  for(let attempt=0;attempt<3;attempt++){
    let result=snapshot,consistent=true;
    for(let start=0;start<all.length;start+=6){
      const part=await read(all.slice(start,start+6));
      if((part.worldEpoch??0)!==(snapshot.worldEpoch??0)||(part.moderationRevision??0)!==(snapshot.moderationRevision??0)){snapshot=part;consistent=false;break;}
      result=mergeWorld(result,part);
    }
    if(consistent)return result;
  }
  throw new Error('Artwork visibility is changing. Retry the street refresh; your draft is safe.');
}
